<template>
    <div class="root">
        <label class="col-sm-12">
            Email
            <a @click.prevent="showform=true;focus()" v-if="showform==false" class="glyphicon glyphicon-plus" ></a>
            <small v-if="showform==true" class="text-primary"><b>Pressione ESC para sair</b></small>
        </label>
        <div v-if="showform" @keyup.enter="add()" @keyup.esc="reset()" class="col-sm-12 form">
            <div class="col-sm-5">
                <input type="text" v-model="iptEndereco" ref="iptendereco" placeholder="endereço de em@il" class="form-control">
            </div>
            <div class="col-sm-5">
                <input type="text" v-model="iptDescricao" placeholder="Contato" class="form-control">
            </div>
            <div class="col-sm-2">
                <button @click.prevent="add()" class="btn btn-primary">Adicionar</button>
            </div>
        </div>
        <div class="col-sm-12">
            <ul class="list-inline">
                <li v-for="(email,index) in emails">
                    <span class="text-primary">
                        <a :href="'mailto:'+email.endereco">{{email.endereco}}</a>
                    </span><br/>
                    <small>...{{email.descricao}}</small>
                    <a class="glyphicon glyphicon-pencil" @click.prevent="update(index)"></a>
                    <a class="glyphicon glyphicon-remove" @click.prevent="remove(index)"></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'telefone',
      props: ['emails'],
      data () {
        return {
          showform: false,
          iptEndereco: '',
          iptDescricao: '',
          index: -1
        }
      },
      methods: {
        add () {
          const item = {'endereco': this.iptEndereco, 'descricao': this.iptDescricao}
          this.$emit('add', item, 'email', this.index)
          this.reset()
        },
        update (index) {
          let email = this.emails[index]
          this.iptEndereco = email.endereco
          this.iptDescricao = email.descricao
          this.index = index
          this.showform = true
          this.focus()
        },
        remove (index) {
          this.$emit('remove', 'email', index)
        },
        focus () {
          this.$nextTick(() => { this.$refs.iptendereco.focus() })
        },
        reset () {
          this.showform = false
          this.iptEndereco = ''
          this.iptDescricao = ''
          this.index = -1
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CliFormEmail.vue